export type RadioButtonProps = {
  name: string;
  label: string;
  disabled?: boolean;
  isSelected: boolean;
  value?: string;
  onChange: (s: string | undefined) => void;
  reversed?: boolean;
};

export const RadioButton = (props: RadioButtonProps) => {
  const { name, label, disabled, isSelected, value, onChange, reversed } =
    props;
  let extraClass = isSelected ? "radio-button-selected" : "";
  if (reversed) extraClass += " radio-button-reversed";
  return (
    <div className={`radio-button ${extraClass}`.trim()}>
      <div className="header">
        <input
          id={`${name}-${label}`}
          name={name}
          type="radio"
          disabled={disabled}
          checked={isSelected || false}
          aria-checked={isSelected}
          value={value}
          tabIndex={0}
          onChange={() => onChange(value)}
        />
        <label htmlFor={`${name}-${label}`}>{label}</label>
      </div>
    </div>
  );
};
